import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '../../../types/deviation';
import { useCopyDeviationLinkClick } from '../../../utils/hooks/useCopyLinkClick';
const ShareOnSocial = ({ deviation, stopPropagation })=>{
    const { t } = useTranslation();
    const { onCopyLinkClick } = useCopyDeviationLinkClick(deviation);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ListItemButton, {
        label: t('share.copyLink'),
        onClick: onCopyLinkClick,
        stopPropagation: stopPropagation,
        biData: BiData({
            evid: 357,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue
        }),
        fillContainerWidth: true
    }));
};
ShareOnSocial.displayName = 'ShareOnSocial';
export default ShareOnSocial;

//# sourceMappingURL=ShareOnSocial.js.map